export class WhatsAppOfficialEtapa {
  public id: number;
  public guidclientenapis: string;
  public nome: string;
  public slug: string;
  public ordem: number;
  public cor_hex: string;
  public tipo: string;
  public is_system: boolean;
  public permite_edicao_nome: boolean;
  public permite_exclusao: boolean;
  public is_active: boolean;
  public created_at: Date;
  public updated_at: string;

  constructor() {
    this.tipo = "PIPELINE";
    this.cor_hex = "#00679a";
    this.is_active = true;
  }
}
